import {FETCH_ABOUT_REQUEST, FETCH_ABOUT_SUCCES, FETCH_ABOUT_ERROR} from '../constants/About'
import { jsonGet, errorHandler } from '../utils/Request';

const loadAbout = () => (dispatch) => {
  const apiUrl = '/company/about-company/';
  dispatch({
    type: FETCH_ABOUT_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_ABOUT_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_ABOUT_ERROR
      });
      errorHandler(e);
    });
};

export { loadAbout };



// WEBPACK FOOTER //
// ./src/actions/AboutActions.js